// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  recordId: __t.u64().primaryKey().name("record_id"),
  betrayer: __t.identity(),
  victim: __t.identity(),
  kind: __t.string(),
  worldId: __t.u64().name("world_id"),
  at: __t.timestamp(),
});
